import { CustomCellRendererProps } from "ag-grid-react";
import { Box, IconButton, Typography } from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";
import { useCallListGlobalModalContext } from "@consultants/consultant-profile-new/call-list-global-modal/use-call-list-global-modal-context";
import { ConsultantRowData } from "../../../utils/consultant-row-data";

type Props = CustomCellRendererProps<ConsultantRowData>;

export function CallListStatsRenderer(props: Props) {
  const callListGlobal = useCallListGlobalModalContext();

  return (
    <Box height="100%" p={0.5} display="flex" alignItems="center">
      <Typography display="inline" variant="body2">
        Totalt: {props.data?.callListStats}
      </Typography>

      <Box position="absolute" bottom={4} right={8}>
        <IconButton
          style={{ padding: 0 }}
          onClick={(e) => {
            e.preventDefault();
            callListGlobal.open(props.data._id);
          }}
        >
          <InfoOutlined />
        </IconButton>
      </Box>
    </Box>
  );
}
